module.exports = __webpack_public_path__ + "static/media/ic_select_arrow.aebd052b.svg";